import React,{useEffect} from 'react'
import { useGlobalContext } from '../context'
import {Link} from 'react-router-dom'
import {AiFillYoutube,AiFillInstagram,AiFillFacebook} from 'react-icons/ai'

const Cart = () => {
    const {cart,increaseCount,decreaseCount,clearCart,amount} = useGlobalContext()
    useEffect(()=>{
        window.scrollTo(0,0)
    },[])
    // console.log(cart);
    if(cart.length === 0){
        return (
            <div className='clear_cart'  style={{marginTop:'100px',color:'red'}}>
                <h2>Your cart is currently empty</h2>
            </div>
        )
    }
    return (
        <>
          <div className="cart_main">
              <div className="cart_container">
                  <h3 className='clear_cart'>YOUR ITEMS</h3>
                  {cart.map((item)=>{
                      return (
                        <div className='cart_div'>
                            <div key={item.id} className='cart_box'>
                              <div className="cart_img">
                                  <img src={item.img} alt="" />
                                  <div className='cart_text'>
                                  <h3>{item.title}</h3>
                                  {item.total > item.total/item.count ? <p>${item.total.toLocaleString() }  (${item.total/item.count}) per piece</p> : <p>${item.total}</p>}
                                  </div>
                              </div>
                              <div className="cart_count">
                                  <button  onClick={()=> decreaseCount(item.id)} >-</button>
                                  <p >x{item.count}</p>
                                  <button onClick={()=> increaseCount(item.id)}>+</button>
                              </div>
                          </div>
                        </div>
                      )
                  })}
                  <h3 className="clear_cart">Total Amount: ${amount.toLocaleString()}</h3>
                  <div className="clear_cart">
                      <div>

                                <button onClick={() => clearCart()}>Clear Cart</button>
                      </div>
                      <div>
                                <button onClick={() => alert("Thank you for purchasing!")}>Go to Payment</button>

                      </div>
                            </div> 
              </div>
          </div>
          
        </>
    )
}
export default Cart;
                              